export enum ContentFilter {
	HIGH = 'high',
	MEDIUM = 'medium',
	LOW = 'low',
	OFF = 'off',
}
export enum Theme {
	LIGHT = 'light',
	DARK = 'dark',
	AUTO = 'auto',
}

export interface TenorImage {
	id: string;
	tenorUrl: string;
	shortTenorUrl: string;
	description: string;
	createdAt: Date;
	tags: string[];
	url: string;
	height: number;
	width: number;
	preview: TenorImagePreview;
	img: {
		id: string;
		title: string;
		media_formats: {
			[key: string]: {
				url: string;
				dims: [number, number];
				duration: number;
				preview: string;
				size: number;
			};
		};
		created: number;
		content_description: string;
		content_description_source: string;
		itemurl: string;
		url: string;
		tags: string[];
		hasaudio: boolean;
	};
}

export interface TenorImagePreview {
	url: string;
	height: number;
	width: number;
}
